export default __webpack_public_path__ + "static/media/HowItWorks_Step2_TC.e5ff6565.png";